import React, { useState, useRef, useEffect } from 'react';

const TEMPLATES = [
  { value: 'regular', label: 'Regular Signature' },
  { value: 'osmsaas', label: 'OSM SAAS' },
  { value: 'esomar', label: 'Esomar Signature' },
  { value: 'esomarlogo', label: 'Esomar Logo Signature' },
  { value: 'rv', label: 'RV Signature' },
];

function generateOSMSaaSSignature(name, designation, mobile) {
  return `
    <tr>
      <td valign="top" style="padding:0px 8px 0 0;">
        <img src="https://res.cloudinary.com/divergent/image/upload/v1719384781/signature/sign-logo_nquvsk.png">
      </td>
      <td valign="top" style="padding:0px 8px 0 0;">
        <div style="line-height:1em;font-size:0.8em;font-family:Arial;padding-top:5px;color:#5d2d91;font-weight:bold">Creating Value Through Collaboration</div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1.1em;font-size:0.7em;padding-top:2px;font-family:Arial;">
          <b>SINGAPORE | INDIA | INDONESIA | VIETNAM <br>SOUTH KOREA | CHINA | UAE </b>
        </div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;">Download Credentials
          <a href="https://res.cloudinary.com/divergent/image/upload/v1719388034/signature/Global_Deck_dltozf.pdf">here</a>
        </div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;padding-top:5px;color:#5d2d91;"><b><span style="color:#000">Coverage:</span>ASIA, LATAM, GCC</b></div>
      </td>
      <td valign="top" style="font-size:80%;font-family:Arial;border-left:3px solid;border-color:#5d2d91;padding:0px 0 0 8px;">
        <div style="font-size:1.2em;color:#5d2d91;margin-top:4px;"><b>${name}</b></div>
        <div style="line-height:0.7em;font-size:0.7em;">&nbsp;</div>
        <div><span><span style="font-size:1em;line-height:1.5em;font-weight:bold">${designation}</span>&nbsp;&nbsp;</span></div>
        <div>
          <span>
            <span style="font-size:0.8em;color:#5d2d91;"><b>Mobile:</b></span>
            <span style="font-size:0.8em;">${mobile}</span>
          </span>
        </div>
      </td>
    </tr>
  `;
}

function generateBaseSignature(name, designation, mobile, isEsomar, mobileSg, kakaotalk, showEsomarLogo) {
  return `
    <tr>
      <td valign="top" style="padding:0px 8px 0 0;">
        <img src="https://res.cloudinary.com/divergent/image/upload/v1719384781/signature/sign-logo_nquvsk.png">
      </td>
      <td valign="top" style="padding:0px 8px 0 0;">
        <div style="line-height:1em;font-size:0.8em;font-family:Arial;padding-top:5px;color:#5d2d91;font-weight:bold">Creating Value Through Collaboration</div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1.1em;font-size:0.7em;padding-top:2px;font-family:Arial;">
          <b>SINGAPORE | INDIA | INDONESIA | VIETNAM <br>SOUTH KOREA | CHINA | UAE </b>
        </div>
        <div style="line-height:1em;font-size:0.7em;">&nbsp;</div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;">Download Credentials
          <a href="https://res.cloudinary.com/divergent/image/upload/v1719388034/signature/Global_Deck_dltozf.pdf">here</a>
        </div>
        <div style="line-height:1em;font-size:0.7em;font-family:Arial;padding-top:5px;color:#5d2d91;"><b><span style="color:#000">Coverage:</span>ASIA, LATAM, GCC</b></div>
      </td>
      <td valign="top" style="font-size:80%;font-family:Arial;border-left:3px solid;border-color:#5d2d91;padding:0px 0 0 8px;">
        <div style="font-size:1.2em;color:#5d2d91;margin-top:4px;"><b>${name}</b></div>
        <div style="line-height:0.7em;font-size:0.7em;">&nbsp;</div>
        <div><span><span style="font-size:1em;line-height:1.5em;font-weight:bold">${designation}</span>&nbsp;&nbsp;</span></div>
        ${isEsomar && !showEsomarLogo
          ? `<div><span><span style="font-size:1em;line-height:1.5em;font-weight:bold;color:#5D2D91">ESOMAR MEMBER</span>&nbsp;&nbsp;</span></div>`
          : ''}
        ${mobileSg
          ? `<div><span><span style="font-size:0.8em;color:#5d2d91;"><b>Mobile(India): </b></span><span style="font-size:0.8em;">${mobile}</span></span></div>
             <div><span><span style="font-size:0.8em;color:#5d2d91;"><b>Mobile(Singapore): </b></span><span style="font-size:0.8em;">${mobileSg}</span></span></div>
             <div><span><span style="font-size:0.8em;color:#5d2d91;"><b>KakaoTalk: </b></span><span style="font-size:0.8em;">${kakaotalk}</span></span></div>`
          : `<div><span><span style="font-size:0.8em;color:#5d2d91;"><b>Mobile:</b></span><span style="font-size:0.8em;">${mobile}</span></span></div>`}
        ${showEsomarLogo || mobileSg
          ? `<div style="padding-top:10px"><span><span><img src="https://res.cloudinary.com/divergent/image/upload/v1719384780/signature/esomar_euguuq.png"></span></span></div>`
          : ''}
      </td>
    </tr>
  `;
}

function buildSignatureHTML(template, name, designation, mobile, mobileSg, kakaotalk, showBanner) {
  let rowsHTML = '';
  let rvImageHTML = '';

  if (template === 'rv') {
    rvImageHTML = `<div style="padding-bottom:10px"><img src="https://res.cloudinary.com/divergent/image/upload/v1719384781/signature/rvsign_ocyblk.jpg"></div>`;
    rowsHTML = generateBaseSignature(name, designation, mobile, false, mobileSg, kakaotalk, false);
  } else if (template === 'osmsaas') {
    rowsHTML = generateOSMSaaSSignature(name, designation, mobile);
  } else {
    rowsHTML = generateBaseSignature(
      name, designation, mobile,
      template !== 'regular',
      null, null,
      template === 'esomarlogo'
    );
  }

  const bannerHTML = showBanner
    ? `<tr>
        <td valign="top" style="padding:0px 0px 0 0;border-top:3px solid;border-color:#5d2d91;" colspan="3">
          <img src="https://res.cloudinary.com/divergent/image/upload/v1752237328/signature/banner_j1gzmz_.png" style="width:100%;display:block;">
        </td>
      </tr>`
    : '';

  const osmFooter = template === 'osmsaas'
    ? `<tr>
        <td valign="top" style="padding:0px;border-top:3px solid;border-color:#5d2d91;" colspan="3">
          <table width="100%" cellpadding="0" cellspacing="0" style="font-family:Arial,sans-serif;background-color:#f5f5f5;">
            <tr><td style="padding:6px 12px;">
              <table width="100%" cellpadding="0" cellspacing="0">
                <!-- Row 1: RapidSay Branding with small logo -->
                <tr><td style="padding-bottom:4px;border-bottom:1px solid #ede9f0;">
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tr>
                      <td valign="top" style="padding-right:6px;width:28px;">
                        <a href="https://gmos.rapidsay.com/" style="text-decoration:none;" target="_blank">
                          <img src="https://gmos.rapidsay.com/media/logos/gmos_logo.png" style="height:28px;width:auto;display:block;border-radius:2px;">
                        </a>
                      </td>
                      <td valign="middle" style="padding-left:4px;">
                        <div style="font-size:11px;color:#5d2d91;font-weight:bold;line-height:1.2;margin-bottom:1px;">RapidSay – Global Survey Sampling</div>
                        <div style="font-size:9px;color:#6d5d8f;line-height:1.3;font-weight:500;">Your trusted platform for global survey sampling and respondent access.</div>
                      </td>
                    </tr>
                  </table>
                </td></tr>
                <!-- Row 2: OSM Branding -->
                <tr><td style="padding:5px 0px;border-bottom:1px solid #ede9f0;">
                  <div style="font-size:10px;color:#5d2d91;line-height:1.4;font-weight:600;">An all-in-one online survey management platform for seamless project bidding, execution, and delivery.</div>
                <div style="font-size:12px;color:#5d2d91;font-weight:bold;margin-bottom:1px;text-align:center;">🚀 Powered by OSM</div>
                  </td></tr>
                <!-- Row 3: Feature Highlights with checkmarks -->
                <tr><td style="padding:5px 0px;border-bottom:1px solid #ede9f0;background-color:#fcfbfd;">
                  <table width="100%" cellpadding="2" cellspacing="0" style="background-color:#fcfbfd;">
                    <tr><td align="center" style="font-size:10px;color:#5d2d91;line-height:1.5;font-weight:600;">
                      <span style="color:#5d2d91;font-weight:bold;">✓</span> Smart Bidding&nbsp;&nbsp;
                      <span style="color:#5d2d91;">|</span>&nbsp;&nbsp;
                      <span style="color:#5d2d91;font-weight:bold;">✓</span> Multi Country Projects&nbsp;&nbsp;
                      <span style="color:#5d2d91;">|</span>&nbsp;&nbsp;
                      <span style="color:#5d2d91;font-weight:bold;">✓</span> White Label
                    </td></tr>
                  </table>
                </td></tr>
                <!-- Row 4: Call To Action Button -->
                <tr><td style="padding:7px 0px;text-align:center;">
                  <a href="https://osm.diverhentinsights.com/" style="background-color:#5d2d91;color:#ffffff;text-decoration:none;font-weight:bold;font-size:11px;padding:7px 18px;display:inline-block;border-radius:3px;letter-spacing:0.3px;box-shadow:0 2px 4px rgba(93,45,145,0.2);" target="_blank">📅 BOOK A DEMO HERE</a>
                </td></tr>
              </table>
            </td></tr>
          </table>
        </td>
      </tr>`
    : '';

  return { rvImageHTML, tableBodyHTML: rowsHTML + bannerHTML + osmFooter };
}

export default function SignatureGenerator() {
  const [template, setTemplate] = useState('regular');
  const [name, setName] = useState('');
  const [designation, setDesignation] = useState('');
  const [mobile, setMobile] = useState('');
  const [mobileSg, setMobileSg] = useState('');
  const [kakaotalk, setKakaotalk] = useState('');
  const [showBanner, setShowBanner] = useState(true);
  const [copyMsg, setCopyMsg] = useState('');
  const previewRef = useRef(null);

  const { rvImageHTML, tableBodyHTML } = buildSignatureHTML(
    template, name, designation, mobile, mobileSg, kakaotalk, showBanner
  );

  const fullPreviewHTML = `${rvImageHTML}<table style="border:1px solid #5d2d91"><tbody>${tableBodyHTML}</tbody></table>`;

  const handleCopy = () => {
    const el = previewRef.current;
    if (!el) return;
    const range = document.createRange();
    range.selectNodeContents(el);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    document.execCommand('copy');
    sel.removeAllRanges();
    setCopyMsg('Signature copied to clipboard!');
    setTimeout(() => setCopyMsg(''), 3000);
  };

  const styles = {
    page: {
      background: '#f5f5f5',
      minHeight: '100vh',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      gap: '40px',
      flexWrap: 'wrap',
    },
    inputSection: {
      flex: 1,
      minWidth: '300px',
      background: '#fff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    previewSection: {
      flex: 2,
      minWidth: '500px',
      background: '#fff',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    h1: {
      color: '#5d2d91',
      marginBottom: '20px',
      fontSize: '1.6rem',
    },
    formGroup: {
      marginBottom: '15px',
    },
    label: {
      display: 'block',
      marginBottom: '5px',
      color: '#333',
      fontSize: '14px',
    },
    input: {
      width: '100%',
      padding: '8px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
    },
    select: {
      width: '100%',
      padding: '8px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
    },
    btnPrimary: {
      background: '#5d2d91',
      color: '#fff',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '15px',
      marginRight: '10px',
      marginTop: '10px',
    },
    btnCopy: {
      background: '#28a745',
      color: '#fff',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '15px',
      marginTop: '10px',
    },
    copyMsg: {
      color: '#28a745',
      marginTop: '8px',
      fontSize: '14px',
      fontWeight: 600,
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Input Section */}
        <div style={styles.inputSection}>
          <h1 style={styles.h1}>Signature Generator</h1>

          <div style={styles.formGroup}>
            <label style={styles.label}>Select Template:</label>
            <select
              style={styles.select}
              value={template}
              onChange={e => setTemplate(e.target.value)}
            >
              {TEMPLATES.map(t => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Name:</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Designation:</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter your designation"
              value={designation}
              onChange={e => setDesignation(e.target.value)}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Mobile Number:</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter your mobile number"
              value={mobile}
              onChange={e => setMobile(e.target.value)}
            />
          </div>

          {/* RV-only fields */}
          {template === 'rv' && (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>Mobile (Singapore):</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="Enter Singapore mobile number"
                  value={mobileSg}
                  onChange={e => setMobileSg(e.target.value)}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>KakaoTalk:</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="Enter KakaoTalk ID"
                  value={kakaotalk}
                  onChange={e => setKakaotalk(e.target.value)}
                />
              </div>
            </>
          )}

          <div style={styles.formGroup}>
            <label style={{ ...styles.label, display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={showBanner}
                onChange={e => setShowBanner(e.target.checked)}
              />
              Show Banner Image
            </label>
          </div>

          <div>
            <button style={styles.btnCopy} onClick={handleCopy}>
              Copy Signature
            </button>
          </div>
          {copyMsg && <div style={styles.copyMsg}>{copyMsg}</div>}
        </div>

        {/* Preview Section */}
        <div style={styles.previewSection}>
          <h1 style={styles.h1}>Preview</h1>
          <div
            ref={previewRef}
            dangerouslySetInnerHTML={{ __html: fullPreviewHTML }}
          />
        </div>
      </div>
    </div>
  );
}
